import { isNative } from './platform.js';
import { getTokens, clearTokens } from './tokenStore.js';
import { API_BASE_URL, refreshSession } from './http.js';

// Silêncio de 30s sem nenhum chunk = conexão morta (comum em rede móvel: o
// socket cai sem FIN, e o reader fica pendurado indefinidamente sem isso).
export const STREAM_SILENCE_TIMEOUT_MS = 30000;

async function _streamHeaders() {
  if (!isNative()) return { 'Content-Type': 'application/json' };
  const headers = { 'Content-Type': 'application/json', 'X-Client-Platform': 'native' };
  const tokens = await getTokens();
  if (tokens?.accessToken) headers.Authorization = `Bearer ${tokens.accessToken}`;
  return headers;
}

// Mesmo caminho de plataforma do http.js (Bearer+credentials:'omit' no
// nativo, cookie+credentials:'include' na web) mas fora de request(), que
// consome o corpo inteiro via res.json() — incompatível com um stream SSE
// lido incrementalmente pelo chamador.
export async function openChatStream(path, payload, { signal } = {}) {
  const native = isNative();

  let res = await fetch(`${API_BASE_URL}${path}`, {
    method: 'POST',
    headers: await _streamHeaders(),
    credentials: native ? 'omit' : 'include',
    signal,
    body: JSON.stringify(payload),
  });

  // Token expirado no meio de uma sessão longa: renova e tenta uma única vez
  // antes de abrir o stream (reaproveita o singleton de refresh do http.js,
  // que também evita refreshes simultâneos disparados por outras chamadas).
  if (res.status === 401) {
    let ok = false;
    try {
      ok = await refreshSession(native);
    } catch {
      ok = false;
    }
    if (ok) {
      res = await fetch(`${API_BASE_URL}${path}`, {
        method: 'POST',
        headers: await _streamHeaders(),
        credentials: native ? 'omit' : 'include',
        signal,
        body: JSON.stringify(payload),
      });
    } else {
      // Mesma reação do request() em http.js: sessão morta derruba o usuário
      // para o login, em vez de deixá-lo tentando enviar mensagens em loop.
      if (native) await clearTokens();
      window.dispatchEvent(new Event('auth:expired'));
    }
  }

  return res;
}

// Envolve reader.read() com um timeout de silêncio: se nenhum chunk chegar
// dentro do prazo, rejeita com STREAM_SILENCE_TIMEOUT — o chamador decide
// como abortar (cancelar o reader, mostrar retry).
export function readWithSilenceTimeout(reader, timeoutMs = STREAM_SILENCE_TIMEOUT_MS) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new Error('STREAM_SILENCE_TIMEOUT'));
    }, timeoutMs);

    reader.read().then(
      (result) => { clearTimeout(timer); resolve(result); },
      (err) => { clearTimeout(timer); reject(err); },
    );
  });
}
